import { CatalogPage } from '@/pages/catalog/ui';
import { MainPage } from '@/pages/main/ui';
import { MortgagePage } from '@/pages/mortgage/ui';
import { Notfound } from '@/pages/not_found/ui';
import PrivacyPolicyPage from '@/pages/policy/ui';
import { ProgectPage } from '@/pages/project/ui';
import { AppRoutes } from '@/shared/config/routes';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

export default function RouterProvider() {
    
    return (
        <Router>
            <Routes>
               <Route path={AppRoutes.HOME} element={<MainPage/>} />;
               <Route path={AppRoutes.CATALOG} element={<CatalogPage/>} />;
               <Route path={AppRoutes.MORTGAGE} element={<MortgagePage/>} />;
               <Route path={AppRoutes.PROJECT} element={<ProgectPage/>} />;
               <Route path={AppRoutes.POLICY} element={<PrivacyPolicyPage/>} />
               <Route path={AppRoutes.NOTFOUND} element={<Notfound/>} />;
               <Route path="*" element={<Navigate to={AppRoutes.NOTFOUND} replace />} />
            </Routes>
        </Router>
    )
}